export default __webpack_public_path__ + "static/media/90-merchant-list.a591bd3a.svg";